import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, Subscription, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { PASPrdService } from '../../../services/PASPrd.service';
import { PasService } from '../../../services/pas.service';
import { RouterService } from '../../../services/router.service';
import { IFixedComponentAdd } from '../../Interfaces/Integrations/IProduction';
import { pasdata, pasdataResponse } from '../../Interfaces/ipas';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';


@Component({
  selector: 'app-fixedcomponentadd',
  templateUrl: './fixedcomponentadd.component.html'
})

export class FixedComponentAddComponent implements OnInit, AfterViewInit {
  formInput: FormGroup;
  subRef$: Subscription;
  regsSaved:number= 0;
  public companyId: string;
  userId: string;
  matcher = new ErrorStateMatcher1();
  messageAlert: string = "";
  message: string = "";
  dataList = new MatTableDataSource;
  Columns: string[] = [];
  pasdataResponse: pasdataResponse;
  pasdata: pasdata;
  name: string = "";
  code: string = "";
  pasId: number = 0;
  pasIdComponent: number = 0;
  locationname: string = "";

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  ngAfterViewInit() {
    this.dataList.paginator = this.paginator;
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    //private dataService: DataService,
    //private securityService: SecurityService,
    private routeparent: RouterService,
    private pasService: PasService,
    private _snackBar: MatSnackBar,
    private pasPrdService: PASPrdService,
    private securityParams: ActivatedRoute,
    private dialogRef: MatDialogRef<FixedComponentAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formInput = formBuilder.group({
      code: ['', { validators: [Validators.required], asyncValidators: [this.codeexist.bind(this)], updateOn: 'blur' }],
      //code2: ['', [Validators.required], [this.codeexist.bind(this)] ],
      name: [{ value: null, disabled: true }],
      quantity: [null , [Validators.required, Validators.min(1), Validators.max(9999999)]]
    //  quantity: [null, { validators: [Validators.required, Validators.min(1)] }],
    });
    this.Columns = ['code', 'name', 'quantity'];
  }
    changes: Subject<void>;
    itemsPerPageLabel: string;
    nextPageLabel: string;
    previousPageLabel: string;
    firstPageLabel: string;
    lastPageLabel: string;
    getRangeLabel: (page: number, pageSize: number, length: number) => string;


  selectedvalue: number; selectedview: string;

  ngOnInit() {
    this.pasId =this.data.pasId;
  }


  quantityvalue(control: AbstractControl): Observable<ValidationErrors | null> {   //
    if (control.value == 0) {
      this.SetMessage("");

      //this.messageAlert = "Debe digitar cantidad";
      //this.message= "";
      return of({ 'gte': true, 'Debe digitar cantidad': 10 });
    }
    else {
      this.SetMessage("");
      map(res => {
        return  {  oK: true } ;
      })
    }
  }

  Abort() {
    //this.router..navigate(['/ccselect']);
  }

  SetMessageAlert(msg: string) {
    this.message = "";
    this.messageAlert =msg;
  }

  SetMessage(msg: string) {
    this.message = msg;
    this.messageAlert ="";
  }

  codeexist(control:FormGroup): Observable<ValidationErrors | null>  {
    this.formInput.controls['quantity'].disable();
    try {
      this.SetMessage("Consultando...");
      return this.pasService.GetPASCompanyData(control.value)
        .pipe(map(res => {
        if (res.body.isValid) {
          this.name = res.body.resultData.name.trim() + " " + res.body.resultData.presentation.trim();
          this.formInput.controls['quantity'].enable();
          this.SetMessage("");
          document.getElementById("quantity").focus();
          this.pasIdComponent = res.body.resultData.id;
          //don't have consecuenses those above lines
          //this.formInput.controls["code"].clearAsyncValidators();
          return null;
        }
        else {
          this.name = "No existe";
          this.SetMessageAlert(res.body.error.description);
          document.getElementById("code").focus();
          return { errorcode:true };
          }
        this.message=""
      },
        (e) => {
          console.log(e);
          this.SetMessageAlert(e);
          return { errorcode:true };
        }));
    }
    catch (e) {
      this.SetMessage("");
      return  of(null);
    }
  }
          

  Save()
  {
    this.SetMessage("Grabando...");
    //this.formInput.controls['name'].enable();
    const data: IFixedComponentAdd = {
      pasId: this.pasId,
      pasIdComponent:this.pasIdComponent,
      quantity: this.formInput.value.quantity,
      quantityWaste: 0
    };
    this.formInput.controls['quantity'].reset(); //to disabled Accept button

    this.pasPrdService.AddFixedComponent(data).subscribe(results => {
      if (results.body.isValid) {
        this.regsSaved++;
        this.SetMessage(results.body.resultData.description);
      }
      else {
        this.SetMessageAlert(results.body.error.description);
      }
      this.formInput.controls['quantity'].reset();
      this.formInput.controls['code'].reset();
      this.formInput.controls['name'].reset();
      document.getElementById("code").focus();
    },
      (e) => {
        this.SetMessageAlert(e.error);
        console.log(e);
      });
  }

  //addPermission(permission) {
  //  this.Permissions.push(permission);
  //  if (permission.type == "G") {
  //        this.MenuG.push(permission);
  //  }
  //  else {
  //  }
  //}



  b_gen(link, id) {
        this.router.navigate([link]);
  }

  Close() {
    if (this.regsSaved > 0)
      this.dialogRef.close(true);
    this.dialogRef.close(false);

  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

  hasError(nombreControl: string, validacion: string) {
    const control = this.formInput.get(nombreControl);
    return control.hasError(validacion);
  }

}
